import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(theme => ({
  filterButton: {
    flexShrink: 0,
    padding: '7px 10px',
    backgroundColor: alpha(palette.primary.main, 0.08),
    borderColor: palette.primary.main,
    color: palette.primary.main,
    '&:hover': {
      backgroundColor: alpha(palette.primary.main, 0.16),
      borderColor: palette.primary.main
    },
    '&&& path': {
      fill: palette.primary.main
    }
  },
  filterBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
    minWidth: 22,
    height: 22,
    padding: '0 8px',
    borderRadius: 11,
    backgroundColor: palette.primary.main,
    color: palette.shades[100],
    fontSize: '0.75rem',
    fontWeight: 700
  },
  menuPaper: {
    minWidth: 220,
    maxHeight: 400
  },
  menuList: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'inherit',
    minHeight: 0,
    overflow: 'hidden',
    paddingTop: 8,
    paddingBottom: 0
  },
  menuScrollContent: {
    flex: '1 1 auto',
    minHeight: 0,
    overflow: 'auto',
    paddingBottom: 8
  },
  sectionLabel: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 4,
    textTransform: 'uppercase',
    fontSize: '0.7rem',
    fontWeight: 600
  },
  menuItem: {
    paddingTop: 4,
    paddingBottom: 4
  },
  pricingSearchInput: {
    margin: '0 12px 8px',
    width: 'calc(100% - 24px)',
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.palette.action.hover,
      fontSize: '0.875rem'
    }
  },
  pricingsList: {},
  pricingsListEmpty: {
    padding: '8px 16px'
  },
  divider: {
    marginTop: 8,
    marginBottom: 8
  },
  actionBar: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    padding: '8px 16px',
    borderTop: "1px solid ".concat(theme.palette.divider),
    backgroundColor: theme.palette.background.paper
  }
}));
export default useStyles;